__turbopack_context__.v({
  "boutiqueName": "RepairDetailsRepairPanel-module-scss-module__eVS9dq__boutiqueName",
  "metaBlock": "RepairDetailsRepairPanel-module-scss-module__eVS9dq__metaBlock",
  "metaGrid": "RepairDetailsRepairPanel-module-scss-module__eVS9dq__metaGrid",
  "metaLabel": "RepairDetailsRepairPanel-module-scss-module__eVS9dq__metaLabel",
  "metaValue": "RepairDetailsRepairPanel-module-scss-module__eVS9dq__metaValue",
  "panel": "RepairDetailsRepairPanel-module-scss-module__eVS9dq__panel",
  "plannedDelivery": "RepairDetailsRepairPanel-module-scss-module__eVS9dq__plannedDelivery",
  "quoteCtaRow": "RepairDetailsRepairPanel-module-scss-module__eVS9dq__quoteCtaRow",
  "serviceCentre": "RepairDetailsRepairPanel-module-scss-module__eVS9dq__serviceCentre",
});
